// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".otherTime > p[data-v-19baa880] {\n  margin-left: 0.1rem;\n  margin-bottom: 0.1rem;\n}\n.otherTime > p[data-v-19baa880] .el-radio {\n    margin-right: 0.05rem !important;\n}\n.otherTime > p[data-v-19baa880]:last-child .el-radio__label {\n  padding-left: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
